import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetRestVialActivities(id: string | undefined) {
  return useQuery(queries.stocks.getRestVialActivitiesById(id || ''))
}
